<template>
    <div class="photo-editor" :style="editorStyle" v-show="isShow">
        <p-header title="編輯照片" left-btn="完成" @onLeftBtn="onSend"/>
        <div class="photos">
            <div class="photo" v-for="(photo, index) in photos" :key="index" :style="{'background-image': `url(${photo.content})`}">
                <div class="delete" @click="deletePic(index)">
                    <img src="@/assets/img/del.svg">
                </div>
            </div>
        </div>
        <div class="buttons">
            <input type="file" accept="image/*" ref="pic" @change="pushPic"  hidden>
            <input type="file" accept="image/*" ref="camera" @change="pushPic"  capture="environment"  hidden>
            <div class="button" @click="openPic">
                <img src="@/assets/img/addbtn.svg">
            </div>
        </div>
        <photo-bottom v-if="showPhotoBottom" @onClose="showPhotoBottom = false" @openAlbum="openAlbum" @openCamera="openCamera"/>
    </div>
</template>

<script>
    import Header from "../Header";
    import Compressor from "compressorjs";
    import Swal from "sweetalert2";
    import * as R from "ramda";
    import OpenPhotoBottom from "./OpenPhotoBottom";

    export default {
        name: "PhotoEditor",
        components: {
            'p-header': Header,
            'photo-bottom': OpenPhotoBottom,
        },
        data() {
            return {
                isShow: false,
                photos: [],
                showPhotoBottom: false,
            }
        },
        computed: {
            editorStyle() {
                return {
                    'top': this.isLiquor ? '10vh' : '0',
                    'height': this.isLiquor ? 'calc(100% - 10vh)' : '100%',
                }
            },
            isMobile() {
                if(! /AppleWebKit.*Mobile/i.test(navigator.userAgent) &&
                    ! /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent) &&
                    ! /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent)){
                    return false;
                }

                return true;
            },
        },
        methods: {
            show(photos) {
                this.photos = R.clone(photos);
                this.isShow = true;
                this.$nextTick(() => {
                    if (!this.photos.length) {
                        this.openPic();
                    }
                })
            },
            close() {
                this.isShow = false;
                this.$router.back();
            },
            hidden() {
                this.isShow = false;
            },
            onSend() {
                this.$emit('updatePic', this.photos);
                this.$router.back();
                this.isShow = false;
            },
            deletePic(index) {
                this.photos.splice(index, 1);
            },
            openPic() {
                if (this.photos.length >= 10) {
                    Swal.fire({
                        type: 'warning',
                        title: '照片數量太多',
                        text: '最多只能上傳十張照片唷',
                    });
                    return;
                }

                if (this.isMobile) {
                    this.showPhotoBottom = true;
                } else {
                    this.openAlbum();
                }
            },
            openCamera() {
                this.showPhotoBottom = false;
                this.$refs.camera.click();
            },
            openAlbum() {
                this.showPhotoBottom = false;
                this.$refs.pic.click();
            },
            pushPic(event) {
                let file = event.target.files[0];
                if (!file) {
                    return;
                }

                let self = this;
                new Compressor(file,{
                    quality: 0.1,
                    success(result) {
                        let reader = new FileReader();
                        reader.readAsDataURL(result);
                        reader.onloadend = function() {
                            self.photos.push({
                                'name': result.name,
                                'content': reader.result,
                            });
                            self.$refs.pic.value = '';
                        }
                    },
                    error(err) {
                        console.log(err.message);
                    },
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .photo-editor {
        background-color: #FFFFFF;
        position: absolute;
        left: 0;
        width: 100%;
        z-index: 99;
        display: flex;
        flex-direction: column;
        overflow-y: scroll;

        .photos {
            margin: 10px 25px 80px 25px;
            display: flex;
            flex-wrap: wrap;

            .photo {
                width: calc((100% / 3) - 10px);
                margin: 5px;
                border-radius: 5px;
                box-shadow: 0 2px 8px 0 rgba(51,153,51,0.35);
                background-position: 50% 50%;
                background-size: cover;
                background-repeat: no-repeat;
                position: relative;

                &:after {
                    content: " ";
                    display: block;
                    padding-bottom: 100%;
                }

                .delete {
                    padding: 5px;
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                    cursor: pointer;
                }
            }
        }

        .buttons {
            position: fixed;
            bottom: 25px;
            display: flex;
            justify-content: center;

            .button {
                cursor: pointer;
                user-select: none;
                padding: 5px;
            }
        }
    }

    @media screen and (max-width: 767px) {
        .buttons {
            width: 100%;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 991px) {
        .buttons {
            width: 500px;
        }
    }

    @media screen and (min-width: 992px) and (max-width: 1199px) {
        .buttons {
            width: 500px;
        }
    }

    @media screen and (min-width: 1200px) {
        .buttons {
            width: 500px;
        }
    }
</style>